<template>
  <v-dialog
    v-model="isVisible"
    :max-width="config.width"
    :persistent="config.persistent"
    @keydown.esc="closeDialog"
  >
    <data-card
      :color="config.color"
      :colored-border="config.coloredBorder"
      :dark="config.dark"
      :dense="config.dense"
      :icon="config.icon"
      :sub-title="subTitle"
      :title="title"
      tile
    >
      <template #toolbar-append>
        <v-btn
          color="brand-green-dark"
          icon
          large
          outlined
          style="background-color: var(--v-brand-card-bg-base);"
          @click.native="closeDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>

      <template #default>
        <v-card-text class="pa-4 text-body brand-green-dark--text">
          <slot name="default">
            <div v-safe-html="message" />
          </slot>

          <div class="mt-5 caption">
            <span v-safe-html="config.input" />
            <v-text-field
              v-model="inputData"
              v-mask="'######'"
              :color="config.color"
              autofocus
              clearable
              filled
              hide-details
              hide-spin-buttons
              max="6"
              min="6"
              prepend-inner-icon="mdi-lock"
              type="number"
            />
          </div>
        </v-card-text>
      </template>

      <template #card-actions>
        <v-divider />
        <v-card-actions class="brand-text-title">
          <slot name="card-actions">
            <v-spacer />

            <v-btn
              v-if="config.button.no"
              color="grey"
              outlined
              tile
              @click="closeDialog"
            >
              {{ config.button.no.title }}
            </v-btn>

            <v-btn
              v-if="config.button.yes"
              :color="config.color"
              :dark="isValid ? config.dark : false"
              :disabled="!isValid"
              depressed
              tile
              @click="confirmDialog"
            >
              {{ config.button.yes.title }}
            </v-btn>
          </slot>
        </v-card-actions>
      </template>
    </data-card>
  </v-dialog>
</template>

<script>
import ConfirmPinDialogMixin from '@/theme/default/components/common/ConfirmPinDialog.js'

export default {
  name  : 'ConfirmPinDialog',
  mixins: [ConfirmPinDialogMixin]
}
</script>

<style scoped src="@/theme/default/components/common/ConfirmPinDialog.css"></style>

<style scoped>
</style>
